import { ActionType } from '@ant-design/pro-components';
import { Checkbox, DatePicker, FormInstance } from 'antd';
import CustomSelect from 'base/ui/components/CustomSelect';
import dayjs from 'dayjs';
import useDebounce from 'hooks/useDebounce';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { SearchModel } from 'pages/model';
import { Dispatch, MutableRefObject, useEffect, useState } from 'react';
import { CommonModel } from 'services/Main/common_services';
import { commonPresenter, commonStore } from 'stores/root_store';
import { DATE_FORMAT_DEFAULT, DATE_FORMAT_POST } from 'utils/constants';
import { DataRate } from './dataSurvey';

const { RangePicker } = DatePicker;


type Props = {
  form: FormInstance<any>
  tableRef: MutableRefObject<ActionType | undefined>
  loading: {
    loadingSearch: boolean;
    loading: boolean;
  } & Partial<{
    loadingSearch: boolean;
    loading: boolean;
  }>,
  setLoading: Dispatch<Partial<{
    loadingSearch: boolean;
    loading: boolean;
  }>>


  setDataSearch: (value: SearchModel) => void

  dataSearch: SearchModel
}



const FormSearchBox = ({ form, tableRef, loading, setLoading, setDataSearch, dataSearch }: Props) => {
  // data common date
  const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);
  // disable rangePicker khi chọn ngày từ common
  const [disableRangePicker, setDisableRangePicker] = useState(false);


  // Công ty
  const [listCompany, setListCompany] = useState<CommonModel[]>([]);

  const [listWarranty, setListWarranty] = useState<CommonModel[]>([]);

  // Lấy danh sách common date
  const getListCommonDate = async () => {
    setLoading({ loadingSearch: true })
    await commonPresenter.getListSelectCommonDate(commonStore);
    if (commonStore.commonRespone.isSuccess) {
      setListCommonDate(commonStore.commonRespone.data);
    }
    setLoading({ loadingSearch: false })
  };

  const getDropdownWarranty = async (key = '') => {
    await commonPresenter.getCommonDataByKey(commonStore, "ServiceTechnicalTeam");
    if (commonStore.commonRespone.isSuccess) {
      setListWarranty(commonStore.commonRespone.data)
    }
  }
  const debounceSearchWarranty = useDebounce(getDropdownWarranty, 300);


  // Công ty
  const getDataCompany = async () => {
    await commonPresenter.getCompanyByAccount(commonStore);
    if (commonStore.commonRespone.isSuccess) {
      setListCompany(commonStore.commonRespone.data);
    }
  };

  // Lấy ngày bằng common data
  const getDateByKey = async (key: string) => {
    setLoading({ loadingSearch: true })
    await commonPresenter.getDateByCommonDate(commonStore, key);
    if (commonStore.commonDate.fromDate) {

      // set value ban đầu chp biến để search báo cáo (ngày tháng)
      setDataSearch({
        ...dataSearch,
        fromDate: commonStore.commonDate.fromDate ? dayjs(commonStore.commonDate.fromDate)?.format(DATE_FORMAT_POST) : undefined,
        toDate: commonStore.commonDate.toDate ? dayjs(commonStore.commonDate.toDate)?.format(DATE_FORMAT_POST) : undefined,
        companyId: form.getFieldValue('companyId')
      });


      form.setFieldValue("ngayDanhGia", [
        dayjs(commonStore.commonDate.fromDate),
        dayjs(commonStore.commonDate.toDate),
      ]);
    } else {
      form.setFieldValue("ngayDanhGia", undefined);
    }
    setLoading({ loadingSearch: false })
  };


  //================================================================================================
  //================================================================================================
  //================================================================================================
  useEffect(() => {
    (async () => {
      getDataCompany()
      debounceSearchWarranty()
      await getListCommonDate()
    })()
  }, [])

  return (
    <>
      <SearchForm
        form={form}
        onFinish={(value) => {
          tableRef.current?.reload();
        }}
        column="col-2"
        initialValues={{
          companyCode: '1000'
        }}
      >
        {/* Công ty */}
        <SearchItem
          rules={[{ required: true }]}
          name={"companyCode"}
          label={"Công ty"}
        >
          <CustomSelect
            allowClear
            options={listCompany}
            fieldNames={{ label: "value", value: "key" }}
            showSearch
            filterOption={(input, option) =>
              (option?.value ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </SearchItem>

        <SearchItem
          name={"warrantyCode"}
          label={"Trung tâm bảo hành"}
        >
          <CustomSelect
            allowClear
            showSearch
            mode="multiple"
            filterOption={false}
            fieldNames={{ label: "value", value: "key" }}
            onBlur={async () => await debounceSearchWarranty()}
            options={listWarranty}
            onClear={() => debounceSearchWarranty()}
            onSearch={(value) => {
              value ? debounceSearchWarranty(value) : debounceSearchWarranty()
            }}
          />
        </SearchItem>

        {/* ngày kết thúc */}
        <SearchItem name={"endDate"} label={"Ngày kết thúc"} start>
          <RangePicker placeholder={['Từ ngày', 'Đến ngày']} allowEmpty={[true, true]} className='!w-full' format={DATE_FORMAT_DEFAULT} />
        </SearchItem>

        {/* Đánh giá chất lượng sản phẩm */}
        <SearchItem
          name={"productQualityEvaluation"}
          label={"Đánh giá chất lượng sản phẩm"}
        >
          <CustomSelect
            allowClear
            options={DataRate}
            showSearch
            filterOption={(input, option) =>
              (option?.value ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </SearchItem>
        {/* Đánh giá Chuyên môn/ Nghiệp vụ của nhân viên */}
        <SearchItem
          name={"employeeProfessionalEvaluation"}
          label={"Đánh giá Chuyên môn/ Nghiệp vụ của nhân viên"}
        >
          <CustomSelect
            allowClear
            options={DataRate}
            showSearch
            filterOption={(input, option) =>
              (option?.value ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </SearchItem>
        {/* Đánh giá Hành vi/ Thái độ phục vụ của nhân viên */}
        <SearchItem
          name={"employeeBehaviorEvaluation"}
          label={"Đánh giá Hành vi/ Thái độ phục vụ của nhân viên"}
        >
          <CustomSelect
            allowClear
            options={DataRate}
            showSearch
            filterOption={(input, option) =>
              (option?.value ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </SearchItem>

        {/* Khách hàng không nghe máy/ không liên lạc được */}
        <SearchItem
          name={"customerUnreachable"}
          label={'Khách hàng không nghe máy/ không liên lạc được'}
          valuePropName="checked"
        >
          <Checkbox />
        </SearchItem>

        {/* Khách hàng không ý kiến/ không đánh giá */}
        <SearchItem
          name={"customerNoFeedback"}
          label={'Khách hàng không ý kiến/ không đánh giá'}
          valuePropName="checked"
        >
          <Checkbox />
        </SearchItem>

        {/* Ngày đánh giá  */}
        <SearchItem name={"commonDate"} label={"Ngày thực hiện khảo sát"} start>
          <CustomSelect
            options={listCommonDate}
            fieldNames={{ label: "value", value: "key" }}
            onChange={async (value, option) => {
              if (option) {
                setDisableRangePicker(
                  option.key === "Custom" ? false : true
                );
                await getDateByKey(option.key);
              } else {
                setDisableRangePicker(false);
                form.setFieldValue("ngayDanhGia", undefined);
              }
            }}
            allowClear
          />
        </SearchItem>



        {/* chọn ngày*/}
        <SearchItem name={"ngayDanhGia"} start>
          <RangePicker
            placeholder={['Từ ngày', 'Đến ngày']}
            disabled={disableRangePicker}
            format="DD/MM/YYYY"
            className="w-full"
          />
        </SearchItem>


      </SearchForm>
    </>
  )
}

export default FormSearchBox